export default [
  {
    path: '/moderation',
    name: 'moderation-queue',
    component: () => import('@/views/moderation/ModerationQueue.vue'),
    meta: {
      pageTitle: 'Модерация',
      breadcrumb: [{ text: 'Модерация', active: true }],
      resource: 'moderation',
      action: 'manage',
    },
  },
  {
    path: '/moderation/payouts',
    name: 'moderation-payouts',
    component: () => import('@/views/moderation/ContentPayouts.vue'),
    meta: {
      pageTitle: 'Выплаты редакторам',
      breadcrumb: [{ text: 'Модерация' }, { text: 'Выплаты редакторам', active: true }],
      resource: 'moderation',
      action: 'manage',
    },
  },
  {
    path: '/moderation/my',
    name: 'moderation-my',
    component: () => import('@/views/moderation/MySubmissions.vue'),
    meta: {
      pageTitle: 'Мои правки',
      breadcrumb: [{ text: 'Мои правки', active: true }],
      resource: 'Auth',
      action: 'read',
    },
  },
]
